<template>
    <div>
      <van-nav-bar
        title="安全考试"
        left-text="返回"
        right-text="按钮"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"/>
      <van-row>
        <van-col span = "7"> 
        <van-image
           round
          width="100"
          height="100"
          src="https://img01.yzcdn.cn/vant/cat.jpeg"/>
        </van-col>
        <van-col span = "17"> 
          <van-form @submit="onSubmit">
            <van-field
                v-model="username"
                label-width="40"
                name="姓名"
                label="姓名:"
            />
            <van-field
                v-model="workNo"
                label-width="40"
                name="工号"
                label="工号:"
            />
            <van-field name="radio" label-width="40" label="性别:">
            <template #input>
              <van-radio-group v-model="gender" direction="horizontal">
                <van-radio name="1">男</van-radio>
                <van-radio name="2">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
            <van-field
                v-model="phone" 
                label-width="40"
                name="电话"
                label="电话:"
                :rules="[{ required: true, message: '请填写用户名' }]" />
            <van-field
                v-model="email"
                label-width="40"
                name="邮箱"
                label="邮箱:"
                :rules="[{ required: true, message: '请填写用户名' }]"/>
            <van-field
                readonly
                clickable
                name="picker"
                label-width="40"
                :default-index="defaultInde"
                :value="deptName"
                label="部门:"
                placeholder="点击选择部门"
                @click="showPicker = true"/>
          </van-form>  
        </van-col>    
        <div style="margin: 16px;">
          <van-button round block type="info" native-type="submit">提交</van-button>
        </div>    
      </van-row>
      <van-popup v-model="showPicker" position="top">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConfirm"
              @cancel="showPicker = false" />
      </van-popup> 
    </div>
  </template>
  <script>
    import { Search } from 'vant';
    import  SERVICE_URL from '@/api/url'
    export default {
      name : 'userEdit',
      data () {
        return {
            defaultIndex:0,
            username:"雷布斯",
            phone : 121321,
            email : "QWEQW@LRC",
            gender : 1,
            deptName: "信息技术部",
            workNo : "2305",
            loading : true,
            deptName: '湖州',
            columns: ['杭州', '宁波', '温州', '嘉兴', '湖州'],
            showPicker: false
            }
      },
      mounted () {
        this.showLogin = true;
      },
      methods: {
        onSubmit(){


        },
        onConfirm(value) {
          this.deptName = value;
          this.showPicker = false;
        },
      },

    }
  </script>
  
  <style lang="less" scoped>

  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/user/userEdit.vue